import React, { useCallback, useMemo, useState, useRef } from 'react';
import cn from 'classnames';
import Slider from 'components/UI/Slider';
import MobileCard from './MobileCard';
import ShortsModal from './ShortsModal';
import { observer, insightsShorts as store } from 'store';
import { useStateModal } from 'utils/hooks';

import * as styles from './MobileLayout.module.scss';

function MobileLayout({ items, theme }) {
  const sliderRef = useRef(null);
  const { modalState, showModal, hideModal } = useStateModal();
  const isThemeDark = theme === 'dark';
  const [current, setCurrent] = useState(0);

  const setCurrentKey = useCallback((prev, next) => {
    setCurrent(next);
  }, []);

  const handleAfterChange = index => {
    store.setCurrentIndex(index);
  };

  const settings = useMemo(
    () => ({
      infinite: true,
      centerMode: true,
      centerPadding: 0,
      variableWidth: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      adaptiveHeight: false,
    }),
    [items.length, current],
  );

  const handleCloseModal = () => {
    if (modalState.isOpen) {
      store.resetShortsStore();
    }
    sliderRef.current?.slickGoTo(store.currentIndex, true);
    hideModal();
  };

  const handleCardClick = index => {
    if (index === current) {
      showModal();
      store.setPlaying(true);
    } else {
      sliderRef.current.slickGoTo(index);
    }
  };

  return (
    <div className={cn(styles.sliderContainer, 'defaultSlider')}>
      <Slider
        {...settings}
        beforeChange={setCurrentKey}
        afterChange={handleAfterChange}
        ref={sliderRef}
      >
        {items.map((item, i) => (
          <MobileCard
            key={item.title}
            active={i === current}
            isThemeDark={isThemeDark}
            handleClick={() => handleCardClick(i)}
            {...item}
          />
        ))}
      </Slider>
      {modalState.isOpen && (
        <ShortsModal
          isOpen={modalState.isOpen}
          closeModalCallback={handleCloseModal}
          items={items}
        />
      )}
    </div>
  );
}

export default observer(MobileLayout);
